export const notificationTypeStrings = {
  SUBMIT_VIDEO: 'submitted a new video.',
  REQUEST_VIDEO_APPROVAL: 'has requested video approval.'
};
